// react-quill components
import React, { useMemo } from 'react'
import ReactQuill, { ReactQuillProps } from 'react-quill';

// react-quill styles
import 'react-quill/dist/quill.snow.css';

import EditorRoot from './root';

export interface EditorProps extends ReactQuillProps {
  toolbar?: {
    disableH1?: boolean
  }
}

function Editor (props: EditorProps): JSX.Element {
  const {
    theme: inputTheme,
    readOnly = false,
    toolbar,
    ...rest
  } = props

  const modules = useMemo(() => {
    let header = []
    if (toolbar?.disableH1) {
      header = [2, 3, 4, 5, false]
    } else {
      header = [1, 2, 3, 4, 5, false]
    }
    return {
      toolbar: [
        [{ header }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        ['link']
      ]
    }
  }, [toolbar?.disableH1])

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link'
  ]

  const theme = useMemo(() => {
    if (inputTheme) {
      return inputTheme
    }
    if (readOnly) {
      return 'bubble'
    }
    return 'snow'
  }, [inputTheme, readOnly])
  return (
    <EditorRoot readOnly={readOnly}>
      {(<ReactQuill modules={modules} formats={formats} theme={theme} readOnly={readOnly} {...rest} />) as any}
    </EditorRoot>
  );
}

export default Editor;
